import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Partner, Wallet } from './types'
import { $params } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'

export const walletsMounted = createEvent()

export const setWalletsRequestError = createEvent<RequestError>()

export const getPartnerWalletFailed = createEvent<RequestError | null>()

export const getWallets = fx<void, Wallet[]>({
  method: 'GET',
  url: '/client/{clientId}/wallets',
})
export const getPartner = fx<void, Partner>({
  method: 'GET',
  url: '/partner/',
})

export const $wallets = restore<Wallet[]>(
  getWallets.doneData.map((doneData) => doneData.body),
  [],
)

export const $errorWalletsRequest = restore(setWalletsRequestError, {
  message: '',
  code: 0,
})

export const $partnerWallet = restore<Partner>(
  getPartner.doneData.map((doneData) => doneData.body),
  {
    id: '0',
    withdrawalAmount: 0,
    createdAt: '',
    updatedAt: '',
  },
)

export const $partnerWalletError = restore<RequestError | null>(
  getPartnerWalletFailed,
  null,
).reset([walletsMounted])

sample({
  clock: [walletsMounted],
  source: $params,
  fn: (params) => {
    return {
      query: {
        populate: JSON.stringify([
          'Wallet',
          'Account',
          'Client.partnerProfile',
          'Wallet.client',
        ]),
      },
      url: `/client/${params?.clientID}/wallets`,
    }
  },
  target: [getWallets],
})
sample({
  clock: walletsMounted,
  source: $params,
  fn: (params) => {
    return {
      url: `/partner/${params?.clientID}`,
    }
  },
  target: getPartner,
})

sample({
  clock: getWallets.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setWalletsRequestError],
})

getPartner.fail.watch(({ error }) =>
  getPartnerWalletFailed({ code: error.status, message: error.body.message }),
)

getPartner.done.watch(() => getPartnerWalletFailed(null))
